import type {PS, ServiceTopology} from '@wix/document-services-types'
import _ from 'lodash'
import * as santaCoreUtils from '@wix/santa-core-utils'
const {joinURL} = santaCoreUtils.urlUtils

export function _tempGetAppAppDef(
    ps: PS,
    viewerAppName: string,
    editorAppName: string,
    appDefId: string,
    verbose: boolean
) {
    // TODO: replace once platform apps provision flow has been decided
    function parseAppSources(appSources: string) {
        return _(appSources || '')
            .split(',')
            .invokeMap('split', ':')
            .fromPairs()
            .value()
    }

    function getArtifactUrl(serviceTopology: ServiceTopology, artifactName: string, version: string) {
        const artifactPath = joinURL(serviceTopology.scriptsDomainUrl, 'services', artifactName)
        if (version) {
            return joinURL(artifactPath, version)
        }

        return serviceTopology.scriptsLocationMap[artifactName]
    }

    const pointer = ps.pointers.general.getServiceTopology()
    const serviceTopology = ps.dal.get(pointer)
    const currentUrl = ps.siteAPI.getCurrentUrl()
    const viewerAppVersion = parseAppSources(_.get(currentUrl, ['query', 'viewerPlatformAppSources']))[appDefId]
    const editorAppVersion = parseAppSources(_.get(currentUrl, ['query', 'editorPlatformAppSources']))[appDefId]
    const appData: any = {
        appDefinitionId: appDefId
    }
    if (viewerAppName) {
        _.set(
            appData,
            ['appFields', 'platform', 'viewerScriptUrl'],
            joinURL(
                getArtifactUrl(serviceTopology, viewerAppName, viewerAppVersion),
                `/app${verbose ? '.verbose' : ''}.js`
            )
        )
    }
    if (editorAppName) {
        _.set(
            appData,
            'appFields.platform.editorScriptUrl',
            joinURL(getArtifactUrl(serviceTopology, editorAppName, editorAppVersion), '/editorAppModule.js')
        )
        appData.editorArtifact = editorAppName
    }
    return appData
}
